export default __webpack_public_path__ + "static/media/15.58c9104c.png";